/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { aiIntegrationsGetConfig } from "../funcs/aiIntegrationsGetConfig.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AIIntegrationConfig } from "../models/components/aiintegrationconfig.js";
import {
  GetAIIntegrationConfigRequest,
  GetAIIntegrationConfigSecurity,
} from "../models/operations/getaiintegrationconfig.js";
import { unwrapAsync } from "../types/fp.js";
export type AiIntegrationConfigQueryData = AIIntegrationConfig;

export function prefetchAiIntegrationConfig(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetAIIntegrationConfigRequest,
  security?: GetAIIntegrationConfigSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAiIntegrationConfigQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAiIntegrationConfigQuery(
  client$: GramCore,
  request: GetAIIntegrationConfigRequest,
  security?: GetAIIntegrationConfigSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AiIntegrationConfigQueryData>;
} {
  return {
    queryKey: queryKeyAiIntegrationConfig({
      provider: request.provider,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
    }),
    queryFn: async function aiIntegrationConfigQueryFn(
      ctx,
    ): Promise<AiIntegrationConfigQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(aiIntegrationsGetConfig(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAiIntegrationConfig(
  parameters: {
    provider: string;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "aiIntegrations", "getConfig", parameters];
}
